import React from "react";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  LegendOptions,
  ChartOptions,
} from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export interface ChartData {
  labels: (string | number)[];
  datasets: {
    label: string;
    data: (string | number)[];
    backgroundColor: string[];
    borderColor: string[];
  }[];
}

export function DepartmentChart({
  data,
  options,
  length,
}: {
  data: ChartData;
  options: Object;
  length: number;
}) {
  const getVisibleDepartmentCount = (chart: ChartJS): number => {
    const labels = chart.data.labels || [];
    let visibleDepartmentCount = 0;

    labels.forEach((label, index) => {
      if (!chart.getDataVisibility(index)) {
        return;
      }

      visibleDepartmentCount +=
        length > 5 && label === "Others" ? length - 5 : 1;
    });

    return visibleDepartmentCount;
  };

  const legendOnClick: LegendOptions<"doughnut">["onClick"] = (
    _event,
    legendItem,
    legend
  ) => {
    if (legendItem.index === undefined) {
      return;
    }

    legend.chart.toggleDataVisibility(legendItem.index);
    legend.chart.update();
    legend.chart.draw();
  };

  const chartOptions = {
    ...(options as ChartOptions<"doughnut">),
    plugins: {
      ...(options as { plugins?: { legend?: LegendOptions<"doughnut"> } })
        .plugins,
      legend: {
        ...(options as { plugins?: { legend?: LegendOptions<"doughnut"> } })
          .plugins?.legend,
        onClick: legendOnClick,
      },
    },
  };

  const plugins = [
    {
      id: "0",
      beforeDraw(chart: ChartJS) {
        const { width, height, ctx } = chart;
        ctx.restore();
        const fontSize = (height / 100).toFixed(2);
        ctx.font = `${fontSize}em Inter`;
        ctx.textBaseline = "top";
        const text = getVisibleDepartmentCount(chart).toLocaleString();
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 1.8;
        ctx.fillText(text, textX, textY);
        ctx.save();
      },
      afterDraw(chart: ChartJS) {
        const { width, height, ctx } = chart;
        ctx.restore();
        const fontSize = (height / 250).toFixed(2);
        ctx.font = `${fontSize}em Inter`;
        ctx.textBaseline = "top";
        const text2 = `Total`;
        const textX = Math.round((width - ctx.measureText(text2).width) / 2);
        const textY = height / 2.4;
        ctx.fillText(text2, textX, textY + 20);
        ctx.save();
      },
    },
  ];
  return <Doughnut options={chartOptions} data={data} plugins={plugins} />;
}
